import React from 'react'
import { Loader } from './Loader'
import { ShowImage } from './ShowImage'
import { useMallbrawlShows } from '../hooks/useMallbrawlShows' 

export default function Shows({ filterShows, sortShows, hiddenProperties={} }) {
  const { shows: mallbrawlShows, loading } = useMallbrawlShows()

  if (loading) return <Loader loading={true} />

  const upcomingMallbrawlShows = mallbrawlShows
    .filter(s => s.title 
      && s.title.length > 1
      && s.date 
      && s.date.length > 1
      && (filterShows ? filterShows(s) : true)
    ).sort((a, b) => (a.ts - b.ts) * sortShows)

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column', // stack items vertically
        minHeight: '100vh',      // full viewport height
        padding: '20px',
        color: '#eee',
        backgroundColor: '#222', // optional, just to see centering
      }}
    >
      {upcomingMallbrawlShows.map((show, i) => (
        <div
          key={i}
          style={{
            border: '1px solid #ddd',
            borderRadius: 0,
            padding: '15px',
            marginBottom: '15px',
            backgroundColor: '#333',
            maxWidth: '500px',
            width: '100%'
          }}
        >

          {show['imageLink'] && (
            <ShowImage imgUrl={show.imageLink} />
          )}

        <h2
          style={{
            margin: '0 0 8px',
            fontSize: 24,
            color: '#eee',                // Text color
            WebkitTextStrokeWidth: '1px',  // Outline thickness
            WebkitTextStrokeColor: '#eee', // Outline color
            fontWeight: 'bold',
            backgroundColor: 'var(--red)',        // Highlight color
            display: 'inline-block',       // Keeps text spacing intact
            padding: '0 4px',              // Space around text
          }}
        >
          {show.title.split('\n').map((line, i) => (
            <React.Fragment key={i}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </h2>

          <div style={{ marginBottom: 4 }}>
            <strong>Date:</strong> {show.date}
          </div>

          {!hiddenProperties.locationName ? (
            <div style={{ marginBottom: 4 }}>
              <strong>Location:</strong> {show.locationName}
            </div>
          ): (<></>)}

          {!hiddenProperties.address ? (
            show.addressLink ? (
              <div style={{ marginBottom: 4 }}>
                <strong>Address: </strong>
                <a
                  href={show.addressLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#a8e8eb', textDecoration: 'underline' }}
                >
                  {show.address}
                </a>
              </div>
            ) : (
              <div style={{ marginBottom: 4 }}>
                <strong>Address:</strong> {show.address}
              </div>
            )
          ) : null}

          <div style={{ marginBottom: 4 }}>
            <strong>Doors:</strong> {displayDate(show.doorTime)}
          </div>

          <div style={{ marginBottom: 4 }}>
            <strong>Start:</strong> {displayDate(show.startTime)}
          </div>

          {!hiddenProperties.price ? (
            <div style={{ marginBottom: 4 }}>
              <strong>Price:</strong> {show.price}
            </div>
          ) : null }

          {(show.ticketLink && !hiddenProperties.ticketLink) ? (
            <a
              href={show.ticketLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#a8e8eb', textDecoration: 'underline' }}
            >
              Tickets
            </a>
          ) : 
          <div style={{ marginBottom: 4 }}>
            <strong> {show.ticketText} </strong>
          </div>
        }

          <div style={{ marginBottom: 4 }}>
            <strong> {show.ageRestriction} </strong>
          </div>


          { show.note.length > 0 && (
            <div style={{ marginTop: 12, marginBottom: 4, fontSize: 11, fontStyle:'italic'}}>
              <strong> {show.note} </strong>
            </div>
          )}
        </div>
      ))}
    </div>
  )

  function displayDate(timeStr) {
    const [time, period] = timeStr.split(' ');
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes} ${period}`;
  }
}